import {
    FETCH_OFFERS_STAT_BEGIN,
    FETCH_OFFERS_STAT_ERROR,
    FETCH_OFFERS_STAT_SUCCESS,
    FETCH_PROMO_APPS_STAT_BEGIN,
    FETCH_PROMO_APPS_STAT_ERROR,
    FETCH_PROMO_APPS_STAT_SUCCESS,
    FETCH_REDIRECTS_STAT_BEGIN,
    FETCH_REDIRECTS_STAT_ERROR,
    FETCH_REDIRECTS_STAT_SUCCESS,
    FETCH_RETAIL_CALLS_STAT_BEGIN,
    FETCH_RETAIL_CALLS_STAT_ERROR,
    FETCH_RETAIL_CALLS_STAT_SUCCESS
} from '../actions/promoActions';

const defaultState = {
    stat: [],
    pagination: {},
    loading: false,
    error: null
};

const defaultPromoStat = {
    stat: {
        items: []
    },
    pagination: {},
    loading: false,
    error: null
};

export const promoAppsStat = (state = defaultState, action) => {
    switch (action.type) {
        case FETCH_PROMO_APPS_STAT_BEGIN:
            return {
                ...state,
                loading: true
            };
        case FETCH_PROMO_APPS_STAT_SUCCESS:
            return {
                ...state,
                loading: false,
                stat: action.payload.stat,
                pagination: {
                    numberOfElements : action.payload.numberOfElements,
                    totalElements: action.payload.totalElements,
                    totalPages: action.payload.totalPages
                },
            };
        case FETCH_PROMO_APPS_STAT_ERROR:
            return {
                ...state,
                loading: false,
                stat: []
            };

        default:
            return state;
    }
};

export const promoOffersStat = (state = defaultPromoStat, action) => {
    switch (action.type) {
        case FETCH_OFFERS_STAT_BEGIN:
            return {
                ...state,
                loading: true
            };
        case FETCH_OFFERS_STAT_SUCCESS:
            return {
                ...state,
                loading: false,
                stat: action.payload.stat,
                pagination: {
                    numberOfElements : action.payload.numberOfElements,
                    totalElements: action.payload.totalElements,
                    totalPages: action.payload.totalPages
                },
            };
        case FETCH_OFFERS_STAT_ERROR:
            return {
                ...state,
                loading: false,
            };

        default:
            return state;
    }
};

export const promoRetailCallsStat = (state = defaultPromoStat, action) => {
    switch (action.type) {
        case FETCH_RETAIL_CALLS_STAT_BEGIN:
            return {
                ...state,
                loading: true
            };
        case FETCH_RETAIL_CALLS_STAT_SUCCESS:
            return {
                ...state,
                loading: false,
                stat: action.payload.stat,
                pagination: {
                    numberOfElements : action.payload.numberOfElements,
                    totalElements: action.payload.totalElements,
                    totalPages: action.payload.totalPages
                },
            };
        case FETCH_RETAIL_CALLS_STAT_ERROR:
            return {
                ...state,
                loading: false,
            };

        default:
            return state;
    }
};

export const promoTraderStat = (state = defaultPromoStat, action) => {
    switch (action.type) {
        case FETCH_REDIRECTS_STAT_BEGIN:
            return {
                ...state,
                loading: true
            };
        case FETCH_REDIRECTS_STAT_SUCCESS:
            return {
                ...state,
                loading: false,
                redirectsStatisticItems: action.payload.redirectsStatisticItems,
                pagination: {
                    numberOfElements : action.payload.numberOfElements,
                    totalElements: action.payload.totalElements,
                    totalPages: action.payload.totalPages
                },
            };
        case FETCH_REDIRECTS_STAT_ERROR:
            return {
                ...state,
                loading: false,
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/promoAppsStat.js